import { Button, Input, message, Switch } from 'antd';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';

const ItemContent = ({ item, refreshList }) => {
  const [faq, setFaq] = useState(item);
  const [isEditor, setIsEditor] = useState(false);
  const View = () => {
    return (
      <div>
        <div className="gx-mb-3" dangerouslySetInnerHTML={{__html: item.content}}></div>
        <Button type="default" onClick={()=>setIsEditor(true)}>Perbarui FAQ</Button>
      </div>
    );
  }

  const br2nl = (str, replaceMode) => {   

    var replaceStr = (replaceMode) ? "\n" : '';
    // Includes <br>, <BR>, <br />, </br>
    return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
  }

  const Update = () => {
    return (
      <Formik
        initialValues={{
          title: faq.title,
          content: br2nl(faq.content,false),
          is_active: faq.is_active,
          display_order: faq.display_order
        }}
        onSubmit={values => {
          const url = `/faq/update?id=${faq.id}`;
          axios.post(url, { ...values }).then(resp => {
            message.success(`FAQ dengan judul "${resp.data.title}" telah berhasil diperbarui`);
            setFaq(resp.data);
            setIsEditor(false);
            refreshList();
          }).catch(err => {
            message.error("Gagal memperbarui FAQ");
          });
        }}
      >
        {(formik) => {
          return (
            <Form>
              <div className="gx-mb-2">
                <label htmlFor="title" className="gx-mb-1">Judul FAQ</label>
                <Input name="title" onChange={formik.handleChange} value={formik.values.title} />
              </div>

              <div className="gx-mb-3">
                <label htmlFor="content" className="gx-mb-1">Konten</label>
                <Input.TextArea rows={5} name="content" onChange={formik.handleChange} value={formik.values.content} />
              </div>

              <div className="gx-mb-3">
                <label htmlFor="content" className="gx-mb-1 gx-mr-3">Tampilkan</label>
                <Switch checkedChildren="Ditampilkan" unCheckedChildren="Tidak Ditampilkan" defaultChecked={formik.values.is_active} onChange={(e) => formik.setFieldValue("is_active", e)} />
              </div>

              <div className="gx-mt-3">
                <Button type="primary" htmlType="submit">Simpan Perubahan</Button>
                <Button type="default" onClick={()=>setIsEditor(false)}>Batal</Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    );
  }
  return (
    <Auxiliary>
      {isEditor ? <Update /> : <View />}
    </Auxiliary>
  );
}

export default ItemContent;